import { action, observable } from "mobx";

export class PropertyError {
    message: string;

    constructor(message: string) {
        this.message = message;
    }
}

export interface IFilterable {
    setFilters(filter: string): any;
}

export class FormStore<T> {
    data: T;
    @observable errors: object = {};
    @observable message: string = "";
    onSubmitCallback: (data: T) => Promise<any>;
    onChangeCallback: (data: T) => any;

    constructor(data: T) {
        this.data = data;
    }

    _getValue(path: string[], data: any): any {
        if (path.length === 0) {
            return data;
        }

        const [name, ...rest] = path;

        if (!(name in data)) {
            throw new PropertyError(`Property '${name}' does not exist in the form.`);
        }

        return this._getValue(rest, data[name]);
    }

    getValue(name: string) {
        return this._getValue(name.split("."), this.data);
    }

    getError(name: string) {
        if (!(name in this.errors)) {
            return null;
        }
        return this.errors[name];
    }

    @action
    setErrors(response: any) {
        this.errors = response.errors || {};
        this.message = response.message || "";
    }

    _setValue(path: string[], value: any, data: any): any {
        const [name, ...rest] = path;

        if (path.length === 1) {
            return (data[name] = value);
        }

        if (!(name in data)) {
            throw new PropertyError(`Property '${name}' does not exist in the form.`);
        }

        return this._setValue(rest, value, data[name]);
    }

    @action
    setValue(name: string, value: any) {
        this._setValue(name.split("."), value, this.data);
        if (this.onChangeCallback) {
            this.onChangeCallback(this.data);
        }
    }

    @action
    setData(data: any) {
        for (const property in this.data) {
            if (this.data.hasOwnProperty(property)) {
                this.setValue(property, data[property]);
            }
        }
    }

    @action
    submit = () => {
        this.setErrors({
            errors: [],
            message: ""
        });
        return this.onSubmitCallback(this.data);
    };
}



// WEBPACK FOOTER //
// ./resources/js/stores/FormStore.ts